import { useCallback } from 'react';
import produce from 'immer';
import { v4 as uuid4 } from 'uuid';
import { type AssignmentNodeType, type DetailType, type CrudDataType, CrudEnumType } from './types';
import { ChangeType } from '../../types';
import type { MoreInfo } from '../../types';
import useNodeCrud from '../_base/hooks/use-node-crud';
import { useNodesReadOnly } from '../../hooks';

const useConfig = (id: string, payload: AssignmentNodeType) => {
  const { nodesReadOnly: readOnly } = useNodesReadOnly();
  const { inputs, setInputs } = useNodeCrud<AssignmentNodeType>(id, payload);

  const handleInfoListChange = useCallback(
    (
      newDetail: DetailType,
      moreInfo?: { index: number; payload: MoreInfo },
    ) => {
      if (moreInfo?.payload?.type === ChangeType.remove) {
        // TODO 删除变量时，如果变量已经有连接线，删除连接线
        /* if (
          isVarUsedInNodes([id, moreInfo?.payload?.payload?.beforeKey || ''])
        ) {
          showRemoveVarConfirm();
          setRemovedVar([id, moreInfo?.payload?.payload?.beforeKey || '']);
          setRemoveIndex(moreInfo?.index as number);
          return;
        } */
      }

      const newInputs = produce(inputs, (draft: any) => {
        draft.detail = newDetail;
      });
      setInputs(newInputs);
    },
    [id, inputs, setInputs],
  );

  const handleAddData = useCallback(() => {
    const newInputs = produce(inputs, (draft: AssignmentNodeType) => {
      if(!draft.crudDatas) draft.crudDatas = []
      const data_id = uuid4();
      draft.crudDatas.push({
        id: data_id,
        data: [],
        type: CrudEnumType.create,
      });
    });
    setInputs(newInputs);
  }, [inputs, setInputs]);

  const handleCrudListChange = useCallback(
      (value: CrudDataType[]) => {
        const newInputs = produce(inputs, (draft: AssignmentNodeType) => {
          if (draft.crudDatas) {
            draft.crudDatas = value;
          }
        });
        setInputs(newInputs);
      },
      [inputs, setInputs]
  )
  const handleHashChange = useCallback(
      (value: string | number) => {
        const newInputs = produce(inputs, (draft: any) => {
          draft.hash = value;
        });
        setInputs(newInputs);
      },
      [inputs, setInputs],
    );
  return {
    readOnly,
    inputs,
    handleInfoListChange,
    handleHashChange,
    handleAddData,
    handleCrudListChange
  };
};

export default useConfig;
